import { get, merge } from "lodash";
import GetSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/get";
import userMe from "@/services/user-me";

const executeGetQuery = async (query, queryParams = {}) => {
  const proxy = new GetSimpatraServiceProxy();
  const response = await proxy.execute(query, queryParams);
  const dataResponse = response?.data ?? null;
  return merge(dataResponse, {
    filters: queryParams,
  });
};

const fetch503AProducts = async ({ commit }, { queryParams }) => {
  const currentLocation = get(localStorage, "currentLocation", null);
  const query = `products/v1/location/${currentLocation}/market/pharmacy/search`;

  const response = await executeGetQuery(query, queryParams);
  return response;
};

export default {
  fetch503AProducts,
};
